import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";
import { useLogout } from "utils/useLogout";

interface DeactivationPendingModalProps {
  open: boolean;
  platformName: string;
  contactUrl?: string | null;
}

export const DeactivationPendingModal = ({
  open,
  platformName,
  contactUrl,
}: DeactivationPendingModalProps) => {
  const navigate = useNavigate();
  const logout = useLogout();
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <>
      <div
        className="fixed inset-0 z-50"
        style={{ backgroundColor: "rgba(217, 217, 217, 0.6)" }}
        aria-hidden="true"
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="w-full max-w-[90%] rounded-2xl bg-white shadow-xl sm:max-w-[350px]">
          <div className="flex flex-col gap-6 px-8 py-8">
            <h1 className="font-serif text-[24px] italic leading-tight text-black">
              {t("deactivationPendingModal.title")}
            </h1>
            <div className="flex flex-col gap-3 text-sm leading-[18px] text-secondary">
              <p>{t("deactivationPendingModal.description1")}</p>
              <p>{t("deactivationPendingModal.description2")}</p>
            </div>
          </div>

          <div className="flex w-full flex-col gap-4 px-8 pb-8">
            {contactUrl && (
              <Button
                fullWidth
                onClick={() => {
                  window.location.href = contactUrl;
                }}
              >
                {t("deactivationPendingModal.contactPlatform", { platformName })}
              </Button>
            )}
            <Button fullWidth onClick={() => navigate("/platform-selector")}>
              {t("deactivationPendingModal.switchLocations")}
            </Button>
            <Button fullWidth style="secondary" onClick={logout}>
              {t("deactivationPendingModal.logout")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
